<template>
<div id="frontpage-scoop" :class="frontpage_cls" v-if="frontpage_content">

	<template v-if="frontpage_content.bg_media">
		<template v-if="frontpage_content.bg_media.type==='image'">
			<div id="bgimg" :style="item_bg_css(mediaUrl(frontpage_content.bg_media.id,2500))"></div>
		</template>
		<template v-if="frontpage_content.bg_media.type==='vimeo' || frontpage_content.bg_media.type==='youtube'">
			<div id="bgvid">
				<video-embed-coverfit-bg :type="frontpage_content.bg_media.type" :video_slug="frontpage_content.bg_media.video_slug" />
			</div>
		</template>
	</template>

	<template v-if="frontpage_content.bg_media_mobile">
		<template v-if="frontpage_content.bg_media_mobile.type==='image'">
			<div id="bgimg-mobile" :style="item_bg_css(mediaUrl(frontpage_content.bg_media_mobile.id,2500))"></div>
		</template>
		<template v-if="frontpage_content.bg_media_mobile.type==='vimeo' || frontpage_content.bg_media_mobile.type==='youtube'">
			<div id="bgvid-mobile">
				<video-embed-coverfit-bg :type="frontpage_content.bg_media_mobile.type" :video_slug="frontpage_content.bg_media_mobile.video_slug" />
			</div>
		</template>
	</template>

	
	<div id="bgoverlay"></div>

	<router-link class="bglinker" to="/news"></router-link>

	<a class="left-link" href="https://a-management.eu" target="_blank">
		<div class="title">Artists</div>
	</a>

	<router-link class="right-link" to="/social">
		<div class="title">Social</div>
	</router-link>
	
	<a class="mobile-link-b left" href="https://a-management.eu" target="_blank">
		Artists
	</a>

	<router-link class="mobile-link-b right" to="/social">
		Social
	</router-link>

	<router-link class="mobile-link-c" to="/news">
		Enter site
	</router-link>

	<router-link id="logo-mobile" to="/news">
		<svgicon icon="scoop_models_logo_2liner" />		
	</router-link>

	<div id="centered">
		
		<router-link id="logo" to="/news">
			<svgicon icon="scoop_models_logo" />
			<span id="subline">
				Enter site
			</span>
		</router-link>

	</div>

	<div id="bottomtext">bottomtext</div>


</div>
</template>

<script>
import mixins from '.././mixins.js'
//import '.././components/generated_svg_icons/frontpage_title_artists'
//import '.././components/generated_svg_icons/frontpage_title_social'
//import * as animationData from '.././assets/img/sm_motion_black2.js'
//import VideoEmbed from '.././components/VideoEmbed.vue'
import VideoEmbedCoverfitBg from '.././components/VideoEmbedCoverfitBg.vue'

import '.././components/generated_svg_icons/scoop_social_logo'
import '.././components/generated_svg_icons/scoop_models_logo_2liner'
import '.././components/generated_svg_icons/scoop_models_logo_2liner'

export default {
	
	mixins: [ mixins.generic ],
	
	components: { 		
		VideoEmbedCoverfitBg
	},

	data(){ return {

		

	}},

	computed: {

		frontpage_content(){ return this.$store.state.frontpage_content },

		frontpage_cls(){
			var cls = {}
			if( this.frontpage_content && this.frontpage_content.uicolortheme == 'black' ) cls['uitheme-black'] = true
			return cls
		},


	},

	methods: {

//------------------------------------------------------------------------------------

	item_bg_css(src){
		var css = {}
		if( this.frontpage_content ) css.backgroundImage = 'url('+ src +')'
		return css
	},

//------------------------------------------------------------------------------------

	},

	created(){

		if( !this.frontpage_content ) this.$store.dispatch('fetch_frontpage_content')

	},

	mounted(){	

		var _this = this

		document.documentElement.classList.add('page-frontpage')
		window.prerenderReady = true		
		

	},

	destroyed(){		
		
		document.documentElement.classList.remove('page-frontpage')		
		
	},

}
</script>



// WEBPACK FOOTER //
// src/views/Frontpage.vue